import { PaymentFormComponentsProps } from '@/app/components/ppra/components/ppra-payment-page/PPRAPaymentPage';
import customTheme from '@/constants/theme.custom';
import validationService from '@/services/validation.service';
import { FormControl } from '@chakra-ui/react';
import { Box, Input, Text } from '@cmpsr/components';
import { useElements } from '@stripe/react-stripe-js';

type ZipCodeInputV2Props = PaymentFormComponentsProps & { getPrice: () => void };

export default function ZipCodeInputV2({ form, getPrice }: ZipCodeInputV2Props) {
  const element = useElements();

  const validate = (value: string) => {
    const isValid = validationService.validateZip(value);
    if (isValid) {
      element
        ?.getElement('payment')
        ?.update({ defaultValues: { billingDetails: { address: { postal_code: value } } } });
      getPrice();
    }
    return isValid || 'Please provide a valid zip code';
  };

  const formRegistry = form.register('zip', {
    required: 'Please add your zip code',
    validate,
  });

  return (
    <Box width="100%" display="flex" flexDirection="column" gap={0}>
      <Text
        fontSize="10px"
        fontFamily={customTheme.typography.fonts.inter}
        textTransform="uppercase"
        as="label"
        htmlFor="zip"
      >
        Zip Code
      </Text>
      <FormControl id="zip-code" isInvalid={!!form.formState.errors.zip}>
        <Input
          //          {...styleInputLight}
          placeholder="Enter your zip code"
          id="zip"
          {...formRegistry}
          onBlur={(e) => {
            validate(e.currentTarget.value);
            formRegistry.onBlur(e);
          }}
        />
        {form.formState.errors.zip && (
          <Text color="salmon-light" fontSize="xs" mt={1}>
            {form.formState.errors.zip.message}
          </Text>
        )}
      </FormControl>
    </Box>
  );
}
